import React from 'react';
import { connect } from 'react-redux';
import { Page, Row } from 'shared/containers/portal_layout';
import IconButtonLink, { IconButton } from './IconButtonLink';
import { newReferralButtonClicked } from '../../actions/NewReferralActions';
// import PathToSuccess from 'agent_portal/components/PathToSuccess';

const ProviderEmploymentDashboardPage = (props) => (
  <Page title="Dashboard">
    <p>Welcome to AristaMD!</p>
    <Row>
      <div className="span12 center" style={{ textAlign: 'center' }}>
        <ul className="quick-actions">
          <li>
            <IconButtonLink
              path={`/a/portal/referrals`}
              icon="people"
              label="My Referrals"
            />
          </li>
          <li>
            <IconButton
              path={`/a/portal/referral_profiles/new`}
              icon="survey"
              label="Create Referral"
              onClick={() => props.dispatch(newReferralButtonClicked())}
            />
          </li>
          <li>
            <IconButtonLink
              path="/a/portal/current_agent/edit"
              icon="client"
              label="My Info"
            />
          </li>
        </ul>
      </div>
    </Row>
  </Page>
);

export default connect()(ProviderEmploymentDashboardPage);
